import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TranslateService } from '@ngx-translate/core';
import { Breakpoints } from '@rd-lib/breakpoints';
import { DialogService } from '@rd/popup/services/dialog/dialog.service';
import { tap } from 'rxjs/operators';
import { OfferLocationsDialogComponent } from '../../../offer-ui/components/offer-locations-dialog/offer-locations-dialog.component';
import * as actions from '../actions/offer-locations.actions';

@Injectable()
export class OfferLocationsEffects {
  constructor(
    private actions$: Actions,
    private translateService: TranslateService,
    private dialogService: DialogService,
  ) {}

  showOfferLocationsModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.OfferLocationActionTypes.SHOW_OFFER_LOCATIONS),
        tap((action: actions.ShowOfferLocations) => {
          const isMobileViewport = window.innerWidth < Breakpoints.TABLET;
          const screenMode = isMobileViewport ? 'fullscreen' : 'center-md';

          // payload is offer
          this.dialogService.open(OfferLocationsDialogComponent, {
            data: {
              locations: action.payload.locations,
            },
            id: 'offer-locations-dialog',
            screenMode,
            ariaLabel: this.translateService.instant(
              'offer.locations_modal.title',
            ),
          });
        }),
      ),
    { dispatch: false },
  );
}
